// StorageCleaner.jsx
import { useEffect } from 'react';

import storageCleaner from '../resource/storageCleaner.js';

export const StorageCleaner = () => {
  useEffect(() => {
    storageCleaner();
  }, []);

  return null;
};

export default StorageCleaner;
